import React, { useState, useEffect } from 'react';
import {
    Route,
    Switch,
    useRouteMatch,
    useParams,
} from 'react-router-dom';
import {
    useIsCompetitionsOnlySport,
    useIsMultiGroupedOnlySport,
} from '~SpectateStore/hooks/clientStateHooks';
import isEmpty from 'lodash/isEmpty';
import Homepage from './Homepage';
import Outrights from './Outrights';
import Competitions from './Competitions';
import Events from './Events';
import Event from './Event';
import Error404 from '../ErrorPages/Error404/Error404';
import VirtualSportsLinkBar from '~shared/components/react/VirtualSportsLinkBar';
import { getVirtualGames, getVirtualGameBySlug } from '~shared/services/virtuals';
import { VIRTUAL_GENERIC_SLUG_MAPPINGS } from '~spa/Pages/VirtualSports/constants';
import MultiGrouping from '~scenes/sport/multi-grouping/MultiGrouping';
/**
 * Generic Sports URLs:
 *     /<sport_slug>
 *     /<sport_slug>/all-tournaments
 *     /<sport_slug>/<category_slug>
 *     /<sport_slug>/<category_slug>/competitions
 *     /<sport_slug>/<category_slug>/<tournament_slug>
 *     /<sport_slug>/<category_slug>/<tournament_slug>/outrights
 *     /<sport_slug>/<category_slug>/<tournament_slug>/<event_slug>/
 */

const SportGeneric = () => {
    const { path } = useRouteMatch();
    const { sportSlug } = useParams();

    const isCompetitionsOnlySport = useIsCompetitionsOnlySport(sportSlug);
    const isMultiGroupedOnlySport = useIsMultiGroupedOnlySport(sportSlug);

    const [virtualSport, setVirtualSport] = useState([]);

    useEffect(() => {
        const virtualSportSlug = VIRTUAL_GENERIC_SLUG_MAPPINGS?.[sportSlug];

        if (virtualSportSlug) {
            getVirtualGames().then(virtualSportsList => {
                setVirtualSport(
                    getVirtualGameBySlug(
                        virtualSportsList,
                        virtualSportSlug
                    )
                );
            });
        } else {
            setVirtualSport([]);
        }
    }, [sportSlug]);


    /**
     * Returns the correct component based on props
     * @return  {object}       The correct component
     */
    const getComponent = () => {
        if (isCompetitionsOnlySport) {
            return Competitions;
        }

        if (isMultiGroupedOnlySport) {
            return MultiGrouping;
        }

        return Homepage;
    };

    return (
        <React.Fragment>
            <Switch>
                <Route
                    exact
                    path={`${path}/:categorySlug/:tournamentSlug/outrights`}
                    component={Outrights}
                />
                <Route
                    exact
                    path={`${path}/:categorySlug/:tournamentSlug/:eventSlug/`}
                    component={Event}
                />
                <Route
                    exact
                    path={`${path}/:categorySlug?/competitions`}
                    component={Competitions}
                />
                <Route
                    exact
                    path={`${path}/:categorySlug/:tournamentSlug?`}
                    component={Events}
                />
                <Route
                    exact
                    path={`${path}`}
                    component={getComponent()}
                />
                <Route component={Error404} />
            </Switch>
            {!isEmpty(virtualSport) &&
                <VirtualSportsLinkBar virtualSport={virtualSport} gtmMainComponent={sportSlug} isFooter />
            }
        </React.Fragment>
    );
};

export default SportGeneric;
